import { z } from "zod"

import type { TFunction } from "i18next"

export const createEditTitleSchema = (t?: TFunction) =>
  z.object({
    title: z
      .string()
      .min(1, t?.("pages.ai_parser.validation.title_required") || "Title is required")
      .max(
        100,
        t?.("pages.ai_parser.validation.title_max_length") ||
          "Title must be less than 100 characters"
      ),
  })

export const editTitleSchema = createEditTitleSchema()

export type EditTitleFormData = z.infer<typeof editTitleSchema>
